customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        console.log('🏗️ CONSTRUCTOR: ProductForm initialized');
        (super(), (this.originalButtonText = ""), (this.persistentTextActive = !1));
      }
      connectedCallback() {
        setTimeout(() => {
          if (((this.form = this.querySelector("form")), !this.form)) return;
          const t = this.variantIdInput;
          if (
            (t && this.dataset.productOos !== "true" && (t.disabled = !1),
            this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
            (this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")),
            (this.submitButton = this.querySelector('[type="submit"]')),
            this.submitButton)
          ) {
            if (
              ((this.submitButtonText = this.submitButton.querySelector(".button-text")),
              this.submitButtonText &&
                ((this.originalButtonText = this.submitButtonText.textContent),
                (this.submitButton.dataset.originalText = this.originalButtonText)),
              "true" === this.submitButton.dataset.textOverride && this.submitButtonText)
            ) {
              // Use persistent text when text override is active
              this.persistentTextActive = !0;
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              const t = this.submitButton.dataset.persistentText;
              if (t) {
                if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                  this.submitButtonText.textContent = t;
                }
                localStorage.setItem("addToCartButtonText", t);
              } else {
                const t = localStorage.getItem("addToCartButtonText");
                if (t) {
                  if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                    this.submitButtonText.textContent = t;
                  }
                  this.submitButton.dataset.persistentText = t;
                }
              }
            }
            else if (this.submitButton.classList.contains("has-persistent-text") && this.submitButtonText) {
              this.persistentTextActive = !0;
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              const t = this.submitButton.dataset.persistentText;
              if (t) {
                if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                  this.submitButtonText.textContent = t;
                }
                localStorage.setItem("addToCartButtonText", t);
              } else {
                const t = localStorage.getItem("addToCartButtonText");
                if (t) {
                  if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                    this.submitButtonText.textContent = t;
                  }
                  this.submitButton.dataset.persistentText = t;
                }
              }
            }
            ((this.persistentTextActive || "true" === this.submitButton.dataset.textOverride) &&
              this.submitButtonText &&
              this.setupButtonTextObserver(),
              document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"),
              (this.hideErrors = "true" === this.dataset.hideErrors),
              document.addEventListener("variant:change", this.handleVariantChange.bind(this)));
          }
        }, 100);
        
        // Delay sold-out initialization to ensure submit button is found
        setTimeout(() => {
          this.initializeSoldOutState();
        }, 150);
      }
      
      initializeSoldOutState() {
        console.log('🔄 INIT: Checking initial button state:', {
          hasSubmitButton: !!this.submitButton,
          hasSubmitButtonText: !!this.submitButtonText,
          soldOutStrings: window.variantStrings?.soldOut
        });
        
        if (!this.submitButton) {
          console.log('⚠️ INIT: Submit button not found, trying to find it...');
          // Try to find the submit button manually
          this.submitButton = this.querySelector('button[type="submit"]') || 
                             this.querySelector('.product-form__submit') ||
                             this.querySelector('[id*="ProductSubmitButton"]');
          this.submitButtonText = this.submitButton?.querySelector('.button-text') ||
                                 this.submitButton?.querySelector('span') ||
                                 this.submitButton;
          
          console.log('🔍 INIT: Manual search results:', {
            foundSubmitButton: !!this.submitButton,
            foundSubmitButtonText: !!this.submitButtonText
          });
          
          if (!this.submitButton) {
            console.log('❌ INIT: Still no submit button found, skipping initialization');
            return;
          }
        }
        
        console.log('🔄 INIT: Submit button found, checking state:', {
          hasDisabled: this.submitButton.hasAttribute("disabled"),
          currentText: this.submitButtonText?.textContent,
          hasDataNoOverride: this.submitButtonText?.hasAttribute('data-no-override')
        });
        
        if (this.submitButton.hasAttribute("disabled")) {
          console.log('🚫 INIT: Button is disabled, setting sold-out state');
          this.submitButton.classList.add("sold-out");
          if (this.submitButtonText && window.variantStrings && window.variantStrings.soldOut) {
            // Override data-no-override for sold out state
            const originalNoOverride = this.submitButtonText.dataset.noOverride;
            console.log('🔄 INIT: Removing data-no-override, original value:', originalNoOverride);
            this.submitButtonText.removeAttribute("data-no-override");
            this.submitButtonText.textContent = window.variantStrings.soldOut;
            console.log('✅ INIT: Set button text to:', window.variantStrings.soldOut);
            // Store original no-override value
            if (originalNoOverride) {
              this.submitButtonText.dataset.originalNoOverride = originalNoOverride;
            }
          }
        } else {
          console.log('✅ INIT: Button is available, no sold-out state needed');
        }
      }
      setupButtonTextObserver() {
        if (!this.submitButtonText) return;
        const t = { characterData: !0, childList: !0, subtree: !0 };
        if (this.persistentTextActive) {
          const e = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
          if (!e) return;
          const showPrice = "true" === this.submitButton.dataset.showPrice;
          ((this.buttonTextObserver = new MutationObserver((t) => {
            const currentText = this.submitButtonText.textContent.trim();
            const persistentText = e.trim();
            console.log('👀 OBSERVER: Button text mutation detected:', {
              currentText,
              persistentText,
              showPrice,
              hasDisabled: this.submitButton.hasAttribute("disabled"),
              hasSoldOutClass: this.submitButton.classList.contains("sold-out")
            });
            
            // Don't override if button is sold out
            if (this.submitButton && (this.submitButton.hasAttribute("disabled") || this.submitButton.classList.contains("sold-out"))) {
              console.log('🚫 OBSERVER: Button is sold-out, preventing text override');
              return;
            }
            
            if (showPrice) {
              if (!currentText.startsWith(persistentText)) {
                console.log('✅ OBSERVER: Setting price text:', e);
                this.submitButtonText.textContent = e;
              }
            } else {
              if (currentText !== persistentText) {
                console.log('✅ OBSERVER: Setting persistent text:', e);
                this.submitButtonText.textContent = e;
              }
            }
          })),
            this.buttonTextObserver.observe(this.submitButtonText, t));
        }
      }
      handleVariantChange(t) {
        if (!this.submitButton) {
          console.log('⚠️ VARIANT_CHANGE: Submit button not found, skipping');
          return;
        }
        
        console.log('🔄 VARIANT_CHANGE: Event triggered, checking button state:', {
          hasDisabled: this.submitButton.hasAttribute("disabled"),
          hasSoldOutClass: this.submitButton.classList.contains("sold-out"),
          currentText: this.submitButtonText?.textContent,
          persistentTextActive: this.persistentTextActive
        });
        
        this.submitButtonText &&
          setTimeout(() => {
            // Don't override text if button is sold out
            if (this.submitButton.hasAttribute("disabled") || this.submitButton.classList.contains("sold-out")) {
              console.log('🚫 VARIANT_CHANGE: Button is sold-out, skipping text update');
              return;
            }
            
            console.log('🔄 VARIANT_CHANGE: Button is available, checking persistent text');
            if (this.persistentTextActive) {
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              console.log('📝 VARIANT_CHANGE: Persistent text active, showPrice:', showPrice);
              if (!showPrice) {
                const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
                if (t) {
                  console.log('✅ VARIANT_CHANGE: Setting persistent text:', t);
                  this.submitButtonText.textContent = t;
                }
              }
            }
          }, 50);
      }
      onSubmitHandler(t) {
        t.preventDefault();
        if ("true" === this.dataset.productOos || "true" === this.submitButton.getAttribute("aria-disabled")) return;
        (this.handleErrorMessage(),
          this.submitButton.setAttribute("aria-disabled", !0),
          this.submitButton.classList.add("loading"),
          this.querySelector(".loading__spinner").classList.remove("hidden"));

        const e = fetchConfig("javascript");
        ((e.headers["X-Requested-With"] = "XMLHttpRequest"), delete e.headers["Content-Type"]);
        const s = new FormData(this.form);

        // Check if premium-attachment-kit has already added items[] inputs to the form
        const hasItemsInputs = this.form.querySelector('input[name^="items["]') !== null;

        if (hasItemsInputs) {
          // Premium-attachment-kit has added items[] inputs - use FormData directly

          (this.cart &&
            (s.append(
              "sections",
              this.cart.getSectionsToRender().map((t) => t.id),
            ),
            s.append("sections_url", window.location.pathname),
            this.cart.setActiveElement(document.activeElement)),
            (e.body = s),
            fetch(`${routes.cart_add_url}`, e)
              .then((t) => t.json())
              .then(this.handleCartResponse.bind(this, s, t))
              .catch((t) => {
              })
              .finally(this.handleSubmitFinally.bind(this, t)));
        } else {
          // Original behavior: single product with FormData
          (this.cart &&
            (s.append(
              "sections",
              this.cart.getSectionsToRender().map((t) => t.id),
            ),
            s.append("sections_url", window.location.pathname),
            this.cart.setActiveElement(document.activeElement)),
            (e.body = s),
            fetch(`${routes.cart_add_url}`, e)
              .then((t) => t.json())
              .then(this.handleCartResponse.bind(this, s, t))
              .catch((t) => {
              })
              .finally(this.handleSubmitFinally.bind(this, t)));
        }
      }
      handleCartResponse(formData, event, responseData) {
        if (responseData.status) {
          (publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: responseData.errors || responseData.description,
            message: responseData.message,
          }),
            this.handleErrorMessage(responseData.description));
          const e = this.submitButton.querySelector(".sold-out-message");
          if (!e) return;
          return (
            this.submitButton.setAttribute("aria-disabled", !0),
            this.submitButtonText.classList.add("hidden"),
            e.classList.remove("hidden"),
            void (this.error = !0)
          );
        }
        if (!this.cart) return void (window.location = window.routes.cart_url);
        const e = CartPerformance.createStartingMarker("add:wait-for-subscribers");
        (this.error ||
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
            cartData: responseData,
          }).then(() => {
            CartPerformance.measureFromMarker("add:wait-for-subscribers", e);
          }),
          (this.error = !1));
        const i = this.closest("quick-add-modal");
        i
          ? (document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(responseData);
                  });
                });
              },
              { once: !0 },
            ),
            i.hide(!0))
          : CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(responseData);
            });
      }
      handleSubmitFinally(event) {
        if (
          (this.submitButton.classList.remove("loading"),
          this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"),
          this.error || this.submitButton.removeAttribute("aria-disabled"),
          this.querySelector(".loading__spinner").classList.add("hidden"),
          this.error || "true" !== this.submitButton.dataset.textOverride)
        ) {
          if (!this.error && this.persistentTextActive) {
            const showPrice = "true" === this.submitButton.dataset.showPrice;
            const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            if (t && this.submitButtonText) {
              if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                this.submitButtonText.textContent = t;
              }
            }
          }
        } else;
        CartPerformance.measureFromEvent("add:user-action", event);
      }
      handleErrorMessage(t = !1) {
        this.hideErrors ||
          ((this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")),
            this.errorMessageWrapper.toggleAttribute("hidden", !t),
            t && (this.errorMessage.textContent = t)));
      }
      toggleSubmitButton(t = !0, e) {
        if (!this.submitButton) {
          console.log('⚠️ TOGGLE: Submit button not found, skipping');
          return;
        }
        if (t === false && this.dataset.productOos === "true") {
          return;
        }
        if (t) {
          console.log('🚫 TOGGLE: Disabling button, setting sold-out state:', {
            buttonText: e,
            currentText: this.submitButtonText?.textContent,
            hasDataNoOverride: this.submitButtonText?.hasAttribute('data-no-override')
          });
          this.submitButton.setAttribute("disabled", "disabled");
          // Add sold-out class when button is disabled
          this.submitButton.classList.add("sold-out");
          if (e && this.submitButtonText) {
            // For sold out state, override any text override settings including data-no-override
            const originalNoOverride = this.submitButtonText.dataset.noOverride;
            console.log('🔄 TOGGLE: Removing data-no-override, original value:', originalNoOverride);
            this.submitButtonText.removeAttribute("data-no-override");
            this.submitButtonText.textContent = e;
            console.log('✅ TOGGLE: Button text set to:', e);
            // Store original no-override value to restore later if needed
            if (originalNoOverride) {
              this.submitButtonText.dataset.originalNoOverride = originalNoOverride;
            }
          }
        }
        else {
          console.log('✅ TOGGLE: Enabling button, removing sold-out state:', {
            currentText: this.submitButtonText?.textContent,
            hasOriginalNoOverride: this.submitButtonText?.dataset.originalNoOverride
          });
          this.submitButton.removeAttribute("disabled");
          // Remove sold-out class when button is enabled
          this.submitButton.classList.remove("sold-out");
          // Restore no-override attribute if it existed
          if (this.submitButtonText && this.submitButtonText.dataset.originalNoOverride) {
            console.log('🔄 TOGGLE: Restoring data-no-override:', this.submitButtonText.dataset.originalNoOverride);
            this.submitButtonText.dataset.noOverride = this.submitButtonText.dataset.originalNoOverride;
            delete this.submitButtonText.dataset.originalNoOverride;
          }
          if ("true" === this.submitButton.dataset.textOverride) {
            console.log('📝 TOGGLE: Text override is true, skipping text update');
          }
          else if (this.persistentTextActive) {
            console.log('📝 TOGGLE: Persistent text is active, checking stored text');
            const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            if (t) {
              console.log('✅ TOGGLE: Setting persistent text:', t);
              return void (this.submitButtonText.textContent = t);
            }
          }
          console.log('📝 TOGGLE: Setting fallback text:', {
            hasOriginalText: !!this.originalButtonText,
            hasDatasetOriginalText: !!this.submitButton.dataset.originalText,
            addToCartString: window.variantStrings.addToCart
          });
          this.originalButtonText
            ? (console.log('✅ TOGGLE: Using original button text:', this.originalButtonText), this.submitButtonText.textContent = this.originalButtonText)
            : this.submitButton.dataset.originalText
              ? (console.log('✅ TOGGLE: Using dataset original text:', this.submitButton.dataset.originalText), this.submitButtonText.textContent = this.submitButton.dataset.originalText)
              : (console.log('✅ TOGGLE: Using default addToCart text:', window.variantStrings.addToCart), this.submitButtonText.textContent = window.variantStrings.addToCart);
        }
      }
      disconnectedCallback() {
        (this.buttonTextObserver && this.buttonTextObserver.disconnect(),
          document.removeEventListener("variant:change", this.handleVariantChange));
      }
      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
